import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const usePacingDiamondGet = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["PacingDiamondReport", filters],
    () => {
      const eventIds = filters.events?.map(encodeURIComponent).join(";") || null;
      const asOfDate = filters.asOfDate || null;

      return makeAuthedRequest(
        `v1/reporting/pacing-diamond/year/${filters.year}/eventType/${encodeURIComponent(
          filters.type
        )}/event/${eventIds}/asOf/${asOfDate}`,
        { method: "GET" }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};